import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as content from '../../../../../content'

/** Creates and edits customer-specific connector instances. */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.select.single.Component,
    ds.input.text.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    content.admin.errorMessage.Component,
  ],
  selector: 'atn-integration-connector-modal',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Connector instances for the active Admin zone. */
  public readonly connectorsEc = ngCore.inject(
    state.integrations.connectors.Collection,
  )

  /** Connector definitions available to the active Admin zone. */
  public readonly definitionsEc = ngCore.inject(
    state.integrations.connectorDefinitions.Collection,
  )

  /** Converts persisted definitions to select items without storing UI state. */
  public definitionItems(
    definitions: readonly ents.core.integrations.Connector.Definition[],
  ): readonly { label: string; value: string }[] {
    return definitions.map(definition => ({
      label: definition.name || definition.id,
      value: definition.id,
    }))
  }

  /** Writes the connector's human-readable name into the current draft. */
  public updateName(value: string): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.edit
      .from('IntegrationConnector.Dialog.Name.Changed')
      .dispatch({
        edit: connector => {
          if (connector) {
            connector.name = value
          }
        },
      })
  }

  /** Writes the definition ID into the current connector draft. */
  public updateDefinitionId(
    value: ents.core.integrations.Connector.Definition.Id,
  ): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.edit
      .from('IntegrationConnector.Dialog.Definition.Changed')
      .dispatch({
        edit: connector => {
          if (connector) {
            connector.definitionId = value
          }
        },
      })
  }

  /** Writes the base URL into the current connector draft. */
  public updateBaseUrl(value: string): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.edit
      .from('IntegrationConnector.Dialog.BaseUrl.Changed')
      .dispatch({
        edit: connector => {
          if (connector) {
            connector.baseUrl = value
          }
        },
      })
  }

  /** Writes the API key into a connector creation draft. */
  public updateApiKey(value: string): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.edit
      .from('IntegrationConnector.Dialog.ApiKey.Changed')
      .dispatch({
        edit: connector => {
          if (connector && !('id' in connector)) {
            connector.apiKey = value
          }
        },
      })
  }

  /** Submits the current connector draft. */
  public save(): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.submit
      .from('IntegrationConnector.Dialog.Save.Clicked')
      .dispatch({ current: true, skipUnset: true })
  }

  /** Discards the current connector draft. */
  public cancel(): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.discard
      .from('IntegrationConnector.Dialog.Cancel.Clicked')
      .dispatch({ current: true, skipUnset: true })
  }
}
